import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import DateRangeFilter from '../DateRangeFilter';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function UsersSubscriptionsChart({ data }) {
  const [state, setState] = useState({
    labels: [],
    filteredData: [],
    startDate: new Date('2018-01-01'),
  });

  useEffect(() => {
    if (data) {
      setState({
        labels: data.labels || [],
        filteredData: data.data || [],
        startDate: new Date('2018-01-01'),
      });
    }
  }, [data]);

  const applyDateFilter = (startDate) => {
    if (!data?.user_subscription_details) return;

    const filteredData = [...Array(data.labels.length).keys()].map(() => 0);

    data.user_subscription_details.forEach(({ subscription_id, created_at }) => {
      if (new Date(created_at).getTime() >= startDate.getTime()) {
        filteredData[subscription_id]++;
      }
    });

    setState({
      ...state,
      filteredData,
      startDate,
    });
  };

  const setStartDate = (startDate) => {
    if (!startDate) startDate = new Date('2018-01-01');
    applyDateFilter(startDate);
  };

  // Chart.js v4 options syntax
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Number of users under subscription',
        font: {
          size: 20,
        },
      },
      legend: {
        position: 'top',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        type: 'category',
        display: true,
        grid: {
          offset: false,
        },
        categoryPercentage: 0.2,
      },
      y: {
        type: 'linear',
        display: true,
        position: 'left',
      },
    },
    maintainAspectRatio: false,
  };

  const chartData = {
    labels: state.labels,
    datasets: [
      {
        label: 'Users',
        backgroundColor: '#5568ab',
        borderColor: '#5568ab',
        borderWidth: 1,
        data: state.filteredData,
      },
    ],
  };

  return (
    <div className="piece-subscription-chart chart">
      <DateRangeFilter data={{ startDate: state.startDate, setStartDate }} />
      <div style={{ height: '400px', width: '600px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
}

export default UsersSubscriptionsChart;
